import { BaseResponseCode } from 'shared/entities/network';
import { TranslationString } from 'shared/entities/localization';

import { ExtraBlocksServer } from '../block/server';
import { Permission } from '../permissions';
import { ProjectManagerRoleType } from '../manager';
import type { ProjectSettingsServer } from '../projectSettings/server';

export type ProjectServer = {
  _id: string;
  name: string;
  settings: Pick<ProjectSettingsServer, 'timezone'>;
  permissions: Permission[];
  role: ProjectManagerRoleType;
};

export type ProjectOptionsServer = {
  extra_blocks: ExtraBlocksServer;
};

export enum ProjectFeatures {
  CREATE_PAYMENT_PRODUCTS_DATA = 'CREATE_PAYMENT_PRODUCTS_DATA',
  WZ_OAUTH = 'WZ_OAUTH'
}

export type GetProjectServer = ProjectServer & {
  options: ProjectOptionsServer;
  features: Record<ProjectFeatures, boolean> | {};
};

export const mapBaseErrorCodeToProjectErrorToMessage =
  (
    code: BaseResponseCode.notFound | BaseResponseCode.forbidden
  ): TranslationString =>
  (t) =>
    t(`projects.errors.getting.${code}`, {
      ns: 'entities'
    });
